import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { AppColors } from "../../../util/AppColors";

const FileView = ({ files }) => {
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);

  return (
    <div className="ph20">
      {(files ?? reqDet?.files)?.map((frm, i) => (
        <div className="mt5" key={frm?.fileId}>
          <Typography className="fs12 blue-color font-medium">
            {frm?.name}
          </Typography>
          {frm?.files?.map((fle, i) => (
            <div className="flex-row-ali-cen mt5" key={fle}>
              <a
                href={fle?.replace(/^https:/, "http:")}
                target="_blank"
                className="cursor"
              >
                {fle?.toLowerCase().endsWith(".pdf") ? (
                  <PictureAsPdfIcon
                    className="imghw40"
                    sx={{ color: AppColors.redBtn }}
                  />
                ) : (
                  <img
                    src={fle?.replace(/^https:/, "http:")}
                    className="imghw40 br5"
                    alt=""
                  />
                )}
              </a>
              {/* <div className="gray-dot" />
              <a href={fle} className="fs12 blue-color txt-regular ml5">
                {fle}
              </a> */}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default FileView;
